import PubSub from "pubsub-js";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Common from "../based/Common";
import CommonTable from "../based/CommonTable";
import { CAMPAIGN_TYPE, CONSTANTS, MAINMENU, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import CampaignServices from "../based/services/CampaignServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";

const initialPaging = {
    pageSize: 10,
    pageNumber: 1,
    type: CAMPAIGN_TYPE.MEGA,
};

const CampaignManagement = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [paging, setPaging] = useState(initialPaging);
    const [tableGuid, setTableGuid] = useState(Common.generateGuid());
    const [isBusy, setBusy] = useState(true);
    const [isShowModal, setIsShowModal] = useState(false);
    const [campaignSelected, setCampaignSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState("Đang tải ...");
    const history = useHistory();
    const now = new Date();

    useEffect(() => {
        getCampaigns(paging);
        setBusy(false);
        PubSub.publish(CONSTANTS.SIDEBAR_MENU_TOPIC, {
            mainMenu: MAINMENU.Campaign,
        });
    }, []);

    /** lấy thông tin campaign */
    const getCampaigns = async (paging) => {
        const [err, data] = await CampaignServices.GetListCampaign(paging);
        if (!err && data) {
            setCampaigns(data.listObjects);
            setPaging(data.paging);
        }
    };

    /** handle add config */
    const handleAddConfig = () => {
        setIsShowModal(true);
    };

    /** handle xoá config */
    const handleDelete = (campaigns) => {
        let ids = [];
        campaigns.map((item) => ids.push(item.id));
        ConfirmDialog("Xác nhận xóa?", "Bạn chắc chắn muốn xóa dữ liệu đã chọn?", () => {
            return new Promise(async (resolve, reject) => {
                setBusy(true);
                const [err, data] = await CampaignServices.DeleteCampaigns(ids);
                if (!err && data) {
                    resolve({
                        title: "Thành công",
                        msg: "Xóa thành công.",
                    });
                    setBusy(false);
                    setTableGuid(Common.generateGuid());
                    getCampaigns(paging);
                } else {
                    setBusy(false);
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra. Vui lòng thử lại sau ít phút.");
                }
            });
        });
    };

    /** handle chỉnh sửa config */
    const _handleEditCampaign = (campaign) => {
        setCampaignSelected(campaign);
        setIsShowModal(true);
    };

    const renderAction = () => {
        return (
            <div className="list-button">
                <button
                    className="btn btn-orange"
                    onClick={(e) => {
                        e.preventDefault();
                        history.push("/edit-campaign");
                    }}
                >
                    Tạo chiến dịch mới
                    <i className="fa fa-plus"></i>
                </button>
            </div>
        );
    };

    const renderHeader = () => {
        return (
            <thead>
                <tr>
                    <th className="center">Tên chiến dịch</th>
                    <th className="center">Thời gian diễn ra</th>
                    <th className="center">Mô tả</th>
                    <th className="center">Trạng thái</th>
                    <th className="center"></th>
                </tr>
            </thead>
        );
    };

    const renderBody = () => {
        return (
            <tbody>
                {campaigns && campaigns.length > 0 ? (
                    campaigns.map((campaign, index) => {
                        return (
                            <tr key={index}>
                                <td className="vertical-align-middle">{campaign.title}</td>
                                <td className="vertical-align-middle">
                                    <div className="from">
                                        <span className="sub">Từ</span>
                                        <span>{Common.formatDate(new Date(campaign.startTime))}</span>
                                    </div>
                                    <div className="to">
                                        <span className="sub">Đến</span>
                                        <span>{Common.formatDate(new Date(campaign.endTime))}</span>
                                    </div>
                                </td>
                                <td className="vertical-align-middle">{campaign.description}</td>
                                <td className="center">
                                    {now.getTime() > new Date(campaign.startTime).getTime() && now.getTime() < new Date(campaign.endTime).getTime() ? (
                                        <span className="badge badge-success">Đang diễn ra</span>
                                    ) : (
                                        <span className="badge badge-danger">Đã kết thúc</span>
                                    )}
                                </td>
                                <td className="list-action">
                                    <a
                                        href=""
                                        onClick={(e) => {
                                            e.preventDefault();
                                            history.push(`/edit-campaign/${campaign.id}`);
                                        }}
                                        className="m-1"
                                    >
                                        <span>
                                            <i className="fa fa-edit"></i>
                                            Sửa
                                        </span>
                                    </a>
                                    <a
                                        href=""
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleDelete([campaign]);
                                        }}
                                        className="m-1"
                                    >
                                        <span>
                                            <i className="fa fa-remove"></i>
                                            Xóa
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan="5" className="center">
                            Không có dữ liệu
                        </td>
                    </tr>
                )}
            </tbody>
        );
    };

    return (
        <React.Fragment>
            <Loading show={isLoading} msg={msg} />
            <Breadcum menu={["Trang chủ", "Chiến dịch giảm giá"]} title="Chiến dịch giảm giá" />
            <Wrapper>
                <CommonTable renderAction={renderAction} renderHeader={renderHeader} renderBody={renderBody} paging={paging} datas={campaigns} />
            </Wrapper>
        </React.Fragment>
    );
};

export default CampaignManagement;

const Wrapper = styled.div`
    width: 1400px;

    .list-button {
        margin: 12px 0;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: var(--Cam-Thng-hiu, #ff9027);
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        align-items: baseline;
    }

    button.btn.btn-orange i {
        margin-left: 6px;
    }
    span.sub {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .from span,
    .to span {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    td.list-action {
        display: flex;
        flex-direction: column;
    }

    .list-action span {
        display: flex;
        align-items: baseline;
        color: #303030;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .list-action span i {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
